import { POST, GET } from './api'

export{
    POST,
    GET
}